import { Stack } from '@mantine/core';
import { Button, Text } from '@repo/foundations';
import { memo } from 'react';

export const MessageAiError = memo(
	({
		onRetry,
		isLastMessage,
		limitExceeded,
	}: {
		onRetry?: () => void;
		isLastMessage?: boolean;
		limitExceeded?: boolean;
	}) => (
		<Stack spacing="xs" align="flex-start">
			<Text size="md" color="text/secondary/default">
				{limitExceeded
					? 'prompt limit exceeded'
					: 'This message failed to load.'}
			</Text>
			{isLastMessage && onRetry && !limitExceeded && (
				<Button onClick={onRetry}>Try again</Button>
			)}
		</Stack>
	)
);
